export const formTransformer = (values, keysToTransform = [])=> {
    return Object.keys(values).reduce(function (changedValues, key) {
        if (keysToTransform.includes(key)) {
            changedValues[key] = values[key] === null ? null : values[key].id;
        } else {
            changedValues[key] = values[key];
        }

        return changedValues;
    }, {});
}
